/* ═════════════════════════════════════════════════════════════════════════════
   SRC/COMPONENTS/CHARTS/PRINTMODE.JS — modo impressão dos gráficos
   ─────────────────────────────────────────────────────────────────────────────
   O Recharts anima as séries (Line, Area, Bar) por JavaScript ao montar: a
   linha e o preenchimento crescem da esquerda para a direita em ~1,5 s. O
   relatório PDF é montado e o window.print() dispara logo em seguida — o
   navegador fotografa a página no meio da animação e o gráfico sai cortado
   (a linha para no meio do eixo X). A regra de CSS que zera animation-duration
   no #pdf-print-container não alcança essa animação, que não é CSS.

   O contêiner de impressão (Dashboard121Insights) envolve as páginas em
   <PrintModeContext.Provider value={true}>; todo componente que desenha série
   lê useChartAnimation() e repassa em isAnimationActive. Na tela nada muda.

   USADO POR
   Todo componente com <Line>, <Area> ou <Bar> do Recharts — o teste
   printMode.test.js falha se aparecer série sem isAnimationActive.
   ═══════════════════════════════════════════════════════════════════════════ */
import { createContext, useContext } from "react";

export const PrintModeContext = createContext(false);

/** true na tela (anima normalmente), false dentro do relatório PDF. */
export function useChartAnimation() {
  return !useContext(PrintModeContext);
}
